module.exports = __webpack_public_path__ + "img/shop7-5.1dbe9aab.png";